import { liveConnection } from '../core';

import { gameLiveConnection } from './GameConnection';
import { popupStore } from '../store/popupStore';
import { PopupTypes } from '../constants/popupTypes';
import { betBarStore } from '../store/betBarStore';
import { gameStore } from '../store/gameStore';
import { winBarStore } from '../store/winBarStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { gameEvents } from '../lib/gameEvents';
import { spinBarStore } from '../store/spinBarStore';
import { iframeService } from './iframeService';
import { ValidationType } from '../enums/validationType';
import { initStandardSpinManager } from './standardSpinManager/standardSpinManager';
import { userInfoStore } from '../store/userInfoStore';
import { applicationStore } from '../store/applicationStore';
import { parseNumberByPrecision } from '../helpers/parseNumberByPrecision';
import { bonusTypesEnum } from '../constants/bonusTypes';
import { jackpotInitialState } from '../helpers/jackpotInitialState';
import { loadingStore } from '../store/loadingStore';
import { isMobile } from '../helpers/isMobile';
import { gambleStore } from '../store/gambleStore';
import { openExpiresData, updateExpiresCount } from '../helpers/jackpotHelpers';
import { jackpotConnection } from './JackpotConnection';
import { menuBarStore } from '../store/menuBarStore';
import { betButtonContainerXPositionHandler } from '../helpers/betButtonContainerXPositionHandler';
import { soundService } from './baseSoundService/soundService';
import { userSettingsStore } from '../store/userSettingsStore';
import { balanceUpdateHandler } from '../helpers/balanceUpdateHandler';
import { handleTournamentIcon } from '../helpers/handleTournamentIcon';
import { PG_COIN } from '../constants';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import { parseQuery } from '../helpers/parseQuery';
import { boostedJackpotStore } from '../store/boostedJackpotStore';
import { errorCodes } from '../constants/errorCodes';
import { handleErrorCodesPostMessage } from '../helpers/handleErrorCodesPostMessage';

let collectTimeOut;
export let addToGameTimerId;

class GameService {
  onGetInitialStateResult({
    balance,
    currencyCode,
    quickBets,
    matrix,
    oddsInfo,
    hasJackpot,
    userFreeBets,
    bonusSpinInfo,
    precision,
    rate,
    underMaintenance,
    maxOdd,
    defaultBetAmount,
    validation,
    lastSpinResult,
    tournamentInfo,
    hasGamble,
    boostedJackpotInfo,
  }) {
    if (validation !== ValidationType.Success) return;
    iframeService.sendStakeUpdate(defaultBetAmount);
    gameStore.resetStore();
    spinBarStore.resetStore();
    winBarStore.resetStore();
    gambleStore.resetStore();
    gameMainDrawer.gambleBar.hideGamble();
    gameMainDrawer.betBar.resetLastWinContainerPosition();
    gameMainDrawer.spinBar.showSpinButton();
    if (underMaintenance) {
      gameMainDrawer.notificationBar.startUnderMaintenanceFunctional(underMaintenance);
    }
    if (!hasJackpot) {
      applicationStore.setIsJackpotSocketConnected(true);
    }
    applicationStore.tournamentIconsInfo.length && handleTournamentIcon();
    currencyCode = tournamentInfo ? PG_COIN : currencyCode;
    userInfoStore.setCurrencyCode(currencyCode);
    const gameBalance = tournamentInfo?.pgCoinBalance ? tournamentInfo.pgCoinBalance : balance;
    if (tournamentInfo?.tournamentId) {
      gameStore.setInitialTournamentInfo(tournamentInfo);
      spinBarStore.setTournamentId(tournamentInfo.tournamentId);
    } else {
      gameStore.setInitialTournamentInfo(null);
      spinBarStore.setTournamentId(null);
    }
    if (!hasJackpot && isMobile()) {
      // gameMainDrawer.slotBoard.updateGameLogo();
    }
    gameStore.setHasGamble(hasGamble);
    userInfoStore.setUserConfigs({ rate, gameBalance, precision });
    applicationStore.setHasJackPot(hasJackpot);
    if (!applicationStore.isSocketConnected) {
      const betAmountIndex = quickBets.findIndex((el) => el === +defaultBetAmount);
      betBarStore.setQuickBetArr(quickBets);
      betBarStore.setQuickBetDefaultArr(quickBets);
      betBarStore.setSelectedBetAmountIndex(betAmountIndex);
      betBarStore.setSelectedAmount(defaultBetAmount);
      betBarStore.setDefaultBetAmount(defaultBetAmount);
      betButtonContainerXPositionHandler(betAmountIndex);
    }
    betBarStore.setLimits({
      maxBet: quickBets[quickBets.length - 1],
      minBet: quickBets[0],
      maxOdd,
      boostedJackpotBetAmount: quickBets.find((el) => el >= boostedJackpotInfo?.betAmount),
    });
    if (
      lastSpinResult?.additional?.bonusType === bonusTypesEnum.jackpot &&
      !lastSpinResult?.additional?.openByPlayer
    ) {
      gameMainDrawer.jackpotBar.jackpotTextureContainer.visible = true;
      setTimeout(() => {
        gameMainDrawer.jackpotBar.startJackpotWinPopupAnimation(
          lastSpinResult.winAmount,
          lastSpinResult?.additional.jackpotCard
        );
      }, 500);
    }
    if (boostedJackpotInfo) {
      boostedJackpotStore.setIsBoostedJackpot(boostedJackpotInfo);
      this.boostedJackpotInitialState(boostedJackpotInfo, quickBets);
    }
    if (bonusSpinInfo?.bonusType === bonusTypesEnum.boostedJackpot) {
      gameMainDrawer.boostedWheel.startBoostedWheelContainerGsapAnimation();
      updateExpiresCount(+new Date(bonusSpinInfo.expireTime), true);
    }
    if (bonusSpinInfo?.bonusType === bonusTypesEnum.jackpot) {
      jackpotInitialState(bonusSpinInfo);
      applicationStore.setIsShowJackpot(false);
    } else {
      applicationStore.setIsShowJackpot(hasJackpot && !menuBarStore.isMenuPopupOpen);
    }
    gameStore.setNoWinMatrix(matrix);
    applicationStore.setIsJackPotOpacity(false);
    gameStore.setLastSpinMatrix(lastSpinResult?.matrix);
    gameMainDrawer.betBar.setLastWinContainerPosition();
    const userActiveFreeBets = userFreeBets?.filter((el) => el.remainingCount);
    if (userActiveFreeBets?.length || tournamentInfo?.freeBetCount) {
      gameMainDrawer.freeBetBar.startFreeBetPopup(userActiveFreeBets, tournamentInfo);
    } else {
      spinBarStore.setFreeBetId(null);
      betBarStore.setFreeBetSelectedAmount(null);
    }
    oddsInfo.forEach((item) => item.reverse());
    gameStore.setOddsInfo(oddsInfo);
    gameMainDrawer.introBar.setupPayTableSteps();
    gameMainDrawer.introBar.setupSlideStepRounds();
    gameMainDrawer.introBar.updatePayTableOddInfo();
    gameMainDrawer.introBar.setupSettingsButtons();
    gameMainDrawer.introBar.setupGameRules();
    gameStore.setGameResultMatrix(
      lastSpinResult && lastSpinResult.matrix ? lastSpinResult.matrix : matrix
    );
    if (!applicationStore.isSocketConnected) {
      gameMainDrawer.betBar.setupNormalModeBetButton();
    }
    iframeService.sendLoadedState();
    if (!applicationStore.isSocketConnected) {
      const { start, stop } = initStandardSpinManager(
        gameMainDrawer.slotBar.slotBarReelsContainer,
        gameMainDrawer.slotBar.WinBarContainer
      );
      stop();
      start();
      applicationStore.setIsSocketConnected(true);
    }

    gameMainDrawer.menuBar.updateUserBalance();
    popupStore.close();
    loadingStore.updateLoading({ isGameInitialLoaded: true });
    if (spinBarStore.freeBetId || (spinBarStore?.tournamentId && tournamentInfo?.freeBetCount)) {
      gameMainDrawer.freeBetBar.updateFreeBetSelectedAmount(false);
    }
    gameMainDrawer.popupBar.clearReconnectAnimation();
    gameMainDrawer.popupBar.togglePopupVisibility(false);
    gameMainDrawer.spinBar.hideAutoBetPopup();
    if (!gameMainDrawer.gameJackpot.popupSpriteTexture) {
      gameMainDrawer.gameJackpot.setupJackpotInfoPopup();
    }
    this.stopReels();
    spinBarStore.setIsSpinStart(false);
    soundService.muteMusic(!userSettingsStore.isMusicOn);
    soundService.muteSounds(!userSettingsStore.isSoundOn);
  }

  boostedJackpotInitialState(
    {
      id,
      endTime,
      lastWin,
      poolSize,
      winsCount,
      betAmount,
      largestWin,
      lastWinDate,
      wheelValues,
      leftPoolSize,
      leftWinsCount,
      largestWinDate,
    },
    quickBets = null
  ) {
    const {
      setWheelValues,
      setWinningCount,
      setLastWinnerDate,
      setPrizePoolAmount,
      setBoostedBetAmount,
      setWinningCountLeft,
      setLastWinnerAmount,
      setLargestWinnerDate,
      setLargestWinnerAmount,
      setPrizePoolLeftAmount,
      setBoostedJackpotEndTime,
      setBoostedInitialBetAmount,
    } = boostedJackpotStore;
    setWinningCount(winsCount);
    setWheelValues(wheelValues);
    setPrizePoolAmount(poolSize);
    setLastWinnerAmount(lastWin);
    setLastWinnerDate(lastWinDate);
    setBoostedJackpotEndTime(endTime);
    setLargestWinnerAmount(largestWin);
    setWinningCountLeft(leftWinsCount);
    setLargestWinnerDate(largestWinDate);
    setPrizePoolLeftAmount(leftPoolSize);
    setBoostedInitialBetAmount(betAmount);
    userSettingsStore.updateNewBoostedJackpotById(id);
    gameMainDrawer.boostedJackpot.executeBoostedJackpotIcon();
    gameMainDrawer.boostedWheel.executeWheelDataAndWheel(wheelValues.length, wheelValues);
    gameMainDrawer.boostedInfo.executeBoostedInfoData();
    if (quickBets || userSettingsStore.isBoostedJackpotInitialPopup) {
      gameMainDrawer.boostedJackpot.executeBoostedJackpotInitialPopup();
      const validQuickBet = quickBets.find((el) => el >= betAmount);
      setBoostedBetAmount(validQuickBet);
    }
  }

  handleFreeBetAwarded({ freeBets }) {
    const userActiveFreeBets = freeBets?.filter((el) => el.remainingCount);
    gameMainDrawer.freeBetBar.startFreeBetPopup(userActiveFreeBets);
    gameMainDrawer.freeBetBar.updateFreeBetSelectedAmount(false);
  }

  handleTournamentInfoResult({ tournamentInfo, validation }) {
    if (validation === ValidationType.Success && tournamentInfo) {
      if (tournamentInfo.freeBetCount) {
        gameStore.setInitialTournamentInfo(tournamentInfo);
        spinBarStore.setTournamentId(tournamentInfo.tournamentId);
        gameMainDrawer.betBar.decreaseWinAndLastWinContainerPositionByFreeBet();
        gameMainDrawer.freeBetBar.startFreeBetPopup([], tournamentInfo);
      } else if (tournamentInfo.pgCoinBalance) {
        userInfoStore.setUserBalance(tournamentInfo.pgCoinBalance);
        gameMainDrawer.menuBar.updateUserBalance();
        spinBarStore.setTournamentId(tournamentInfo.tournamentId);
      }
    }
  }

  getTournamentUpdate() {
    const {
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
      [DefaultQueryParams.TournamentId]: tournamentId,
    } = parseQuery(window.location.search);
    gameLiveConnection.getTournamentInfo({ partnerId, gameId, tournamentId });
  }

  getBoostedJackpot() {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    gameLiveConnection.getBoostedJackpotWin(gameId);
  }

  handleBoostedJackpotWinResult(data) {
    if (data.validationType === ValidationType.Success) {
      const { index, winAmount } = data;
      gameMainDrawer.boostedWheel.spinToSectorEndAnimation(index);
      boostedJackpotStore.setSpinWheelWinAmount(winAmount);
    } else {
      this.sendLauncherErrorCode();
      gameMainDrawer.boostedWheel.spinToSectorEndAnimation(null);
    }
  }

  handleBoostedJackpotActivationInfoResult(data) {
    userSettingsStore.setIsBoostedJackpotInitialPopup(true);
    this.boostedJackpotInitialState(data);
  }

  stopReels() {
    if (spinBarStore.isDoubleClick || spinBarStore.gameReelSpeedMode.faster) {
      gameEvents.emit('stopColumnsAtOnce');
    } else {
      setTimeout(() => {
        if (spinBarStore.gameReelSpeedMode.fast) {
          gameEvents.emit('stopColumnsInFastMode');
        } else {
          gameEvents.emit('stopColumnsSequentially');
        }
      }, 200);
    }
  }

  handleSpinResult({
    maxWin,
    result,
    balance,
    winAmount,
    bonusType,
    gambleInfo,
    freeBetInfo,
    odd,
    operatorError,
    validation,
    tournamentInfo,
  }) {
    spinBarStore.setIsSpinStart(true);
    gambleStore.setGambleCount(0);
    if (validation === ValidationType.Success) {
      if (gameStore.hasGamble && gambleInfo && !spinBarStore.isAutoBetStart) {
        gambleStore.setGambleCount(gambleInfo.gambleAttemptsCount);
        gameMainDrawer.gambleBar.updateAttemptsLeftCount(gambleInfo.gambleAttemptsCount);
      }
      gameStore.setBonusType(bonusType);
      const res = result.length ? { matrix: result } : result;
      gameStore.setGameResultMatrix(res.matrix);

      if (freeBetInfo?.reminingSpinCount || tournamentInfo?.currentFreeBetCount) {
        const freeBetCount = tournamentInfo?.tournamentId
          ? tournamentInfo?.currentFreeBetCount
          : freeBetInfo?.reminingSpinCount;
        gameMainDrawer.freeBetBar.updateFreeBetCount(freeBetCount);
      }
      gameStore.setFreeBetInfo(freeBetInfo);
      gameStore.setTournamentInfo(tournamentInfo);
      if (odd) {
        winBarStore.setSpinResultOdd(odd);
      } else {
        winBarStore.setSpinResultOdd(0);
      }
      if (result.additional?.wins?.length) {
        winBarStore.setWins(result?.additional?.wins);
      }
      winBarStore.setExpandingWildData(result?.additional?.expandingWild);
      winBarStore.setMaxWin(maxWin);
      if (applicationStore.isDemo) {
        userInfoStore.setDemoBalance(
          parseNumberByPrecision(
            userInfoStore.demoBalance - betBarStore.selectedAmount,
            1,
            userInfoStore.precision
          )
        );
      } else if (!freeBetInfo) {
        userInfoStore.setUserBalance(balance);
      }
      // if (!spinBarStore.freeBetId) {
      gameMainDrawer.menuBar.updateUserBalance();
      // }
      winBarStore.setWinAmount(winAmount);
      if (winBarStore.isLastSpinWin && !tournamentInfo && !applicationStore.isDemo) {
        gameLiveConnection.getBalance();
      }
      gameMainDrawer.gambleBar.updateWinAndGambleToWinAmount();
    } else {
      if (operatorError) {
        iframeService.sendErrorReceived({
          errorCode: operatorError.errorId,
          errorMessage: operatorError.errorDescription,
        });
        applicationStore.setOperatorError(operatorError);
      }
      if (validation === ValidationType.NotEnoughMoney) {
        gameMainDrawer.popupBar.togglePopupVisibility(true);
        gameMainDrawer.popupBar.setInsufficientAmount();
      } else {
        gameMainDrawer.notificationBar.toggleBetNotAcceptedNotification(true, validation);
      }
      gameStore.setGameResultMatrix(gameStore.noWinMatrix);
      gameMainDrawer.spinBar.hideAutoBetPopup();
    }
    this.stopReels();
  }

  handleReconnecting(error) {
    if (error && error.message) {
      // popupStore.toggleReconnect();
    } else {
      GameService.ReconnectCount += 1;
      // popupStore.toggleReconnect();
    }
  }

  handleJackpotResult(data) {
    gameMainDrawer.gameJackpot.updateJackpotAmounts(data);
    gameMainDrawer.jackpotBar.updateJackpotSceneAmount(data);
  }

  handleJackpotWin(data) {
    gameMainDrawer.gameJackpot.handleJackpotWinData(data);
    winBarStore.setJackpotWinInfo(data);
  }

  handleJackpotWinnerInfoResult(data) {
    gameMainDrawer.gameJackpot.handleJackpotWinnerInfo(data);
    winBarStore.setJackpotInfo(data);
    applicationStore.setIsJackpotSocketConnected(true);
  }

  handleBoostedJackpotExpirationInfoResult() {
    gameMainDrawer.boostedJackpot.BoostedJackpotIconContainer.visible = false;
    spinBarStore.setIsSpinStart(false);
  }

  handleBoostedJackpotWinnerInfoResult(data) {
    const {
      winAmount,
      leftWinsCount,
      leftPoolSize,
      lastWin,
      lastWinDate,
      largestWin,
      largestWinDate,
    } = data;
    const {
      setLastWinnerDate,
      setWinningCountLeft,
      setLastWinnerAmount,
      setLargestWinnerDate,
      setLargestWinnerAmount,
      setPrizePoolLeftAmount,
      setPlayerBoostedWinAmount,
    } = boostedJackpotStore;

    setLastWinnerAmount(lastWin);
    setLastWinnerDate(lastWinDate);
    setLargestWinnerAmount(largestWin);
    setWinningCountLeft(leftWinsCount);
    setLargestWinnerDate(largestWinDate);
    setPrizePoolLeftAmount(leftPoolSize);
    setPlayerBoostedWinAmount(winAmount);
    gameMainDrawer.boostedInfo.updateDataInfoPopup({
      lastWin,
      largestWin,
      lastWinDate,
      leftPoolSize,
      leftWinsCount,
      largestWinDate,
    });
    gameMainDrawer.boostedJackpot.startGsapSliderAnimation(winAmount);
  }

  handleJackpotSceneResult(data) {
    if (data.validation === ValidationType.Success) {
      winBarStore.setJackpotSceneResult(data.jackpotSceneItemInfo);
      openExpiresData(data.jackpotSceneItemInfo);
    }
  }

  handleJackpotSceneItemResult(data) {
    if (data.validation === ValidationType.Success) {
      gameMainDrawer.jackpotBar.updateJackpotItemScene(data);
      winBarStore.setJackpotSceneItemResult(data);
    } else {
      gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.forEach((el) => {
        if (el.key === 'jackpotSymbolContainer' && el.getCurrentAnimationName() !== 'open') {
          el.interactive = true;
          el.buttonMode = true;
          el.stop();
        }
      });
    }
  }

  handleReconnected() {
    gameLiveConnection.sendGameGetInitialState(false);
  }

  handleJackpotConnectionReconnected() {
    jackpotConnection.sendGameGetInitialState(false);
  }

  handleConnectionError() {
    if (GameService.ReconnectCount) {
      // popupStore.onConnectionError(true);
    }
  }

  socketRecursiveReconnecting() {
    try {
      liveConnection.restartGameConnection();
      liveConnection.restartJackpotConnection();
    } catch (err) {
      popupStore.open({ name: PopupTypes.ConnectionError });
      // popupStore.onConnectionError(true);
    }
  }

  handleGambleResult({ isWin, gambleCard, gambleFinished, totalWinAmount, gambleAttemptsCount }) {
    gameMainDrawer.gambleBar.setupHistoryCard(gambleCard);
    gameMainDrawer.gambleBar.updateAttemptsLeftCount(gambleAttemptsCount);
    gambleStore.setIsWin(isWin);
    gambleStore.setGambleFinished(gambleFinished);
    gambleStore.setGambleTotalWinAmount(totalWinAmount);
    gameMainDrawer.gambleBar.handleGambleResultData({
      isGambleWin: isWin,
      gambleWinCard: gambleCard,
      gambleAttemptsCount,
      totalWinAmount,
      gambleFinished,
    });
    gambleFinished && balanceUpdateHandler();
  }

  handleSpinCollectResult({ totalOdd, totalWinAmount, validation }) {
    winBarStore.setIsLastSpinWin(Boolean(totalWinAmount));
    winBarStore.setPrevWinAmount(totalWinAmount);
    gameStore.setCollectValidationType(validation);
    gambleStore.setTotalOdd(totalOdd);
    gameMainDrawer.gambleBar.handleGambleFinished(totalWinAmount, true);
    if (applicationStore.isDemo) {
      balanceUpdateHandler();
    } else {
      clearTimeout(collectTimeOut);
      collectTimeOut = setTimeout(() => {
        balanceUpdateHandler();
      }, 300);
    }
    if (validation === ValidationType.Success && gambleStore.isCollectBeforeSpin) {
      spinBarStore.doSpin();
    } else if (!gameMainDrawer.gambleBar.isCollectSend) {
      gameMainDrawer.notificationBar.toggleBetNotAcceptedNotification(true, validation);
    }
  }

  sendLauncherErrorCode() {
    const { ConnectionError } = errorCodes;
    applicationStore.setIsConnectionLost(true);
    handleErrorCodesPostMessage(ConnectionError);
  }
}

export const gameService = new GameService();
